export const MISC_ITEM_DEFINITIONS = Object.freeze([
    {
        id: "misc.empty_can",
        name: "EMPTY CAN",
        description: "A rinsed steel food can with a jagged lid.",
        category: "MISC",
        tags: ["METAL", "SALVAGE"],
        stackLimit: 20,
        unitMassGrams: 48,
        volumeMl: 400,
        longestDimensionMm: 115,
        iconKey: "can",
        worldAssetId: "small_can",
        scarcity: "COMMON",
        sortOrder: 90,
    },
]);
